import { __decorate } from "tslib";
import { AsnProp, AsnType, AsnTypeTypes, AsnPropTypes } from "@peculiar/asn1-schema";
import { RevokedInfo } from "./revoked_info";
let CertStatus = class CertStatus {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Null, context: 0, implicit: true })
], CertStatus.prototype, "good", void 0);
__decorate([
    AsnProp({ type: RevokedInfo, context: 1, implicit: true })
], CertStatus.prototype, "revoked", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Null, context: 2, implicit: true })
], CertStatus.prototype, "unknown", void 0);
CertStatus = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], CertStatus);
export { CertStatus };
